module.exports = __webpack_public_path__ + "img/PICK_UP_COMPLETE.f117cf1a.svg";